import lottie from 'lottie-web'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export const servicesPreview = () => {

	const el = document.querySelector('[data-animation="services-preview"]')

	if (!el) return

	const items = el.querySelectorAll('[data-index]'),
		headingFirst = el.querySelector('[data-heading="0"]'),
		headingSecond = el.querySelector('[data-heading="1"]')

	const animationFirst = lottie.loadAnimation({
		container: headingFirst,
		renderer: 'svg',
		loop: false,
		autoplay: false,
		path: '/json/headingfirsta.json',
	})

	const animationSecond = lottie.loadAnimation({
		container: headingSecond,
		renderer: 'svg',
		loop: false,
		autoplay: false,
		path: '/json/headingseconda.json',
	})

	if (window.innerWidth < 960) {

		animationFirst.loop = true
		animationSecond.loop = true
		animationFirst.play()
		animationSecond.play()

	} else {

		animationFirst.goToAndStop(60, true)
		animationSecond.goToAndStop(60, true)

		// Item 0 movement
		gsap.fromTo(items[0], {
			y: items[0].offsetHeight * 0.5,
		}, {
			y: 0,
			scrollTrigger: {
				trigger: el,
				start: 'center bottom',
				end: 'center center',
				scrub: true,
				// markers: true,
			}
		})

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: el,
				start: 'center center',
				end: '+=2000',
				pin: true,
				scrub: true,
				// markers: true,
			}
		})

		const calc = (items[1].offsetHeight) + (window.innerHeight * 0.5) - (items[1].offsetHeight * 0.5)

		tl.fromTo(items[1], {
			y: calc
		}, {
			y: 0
		}, 0.6)

		const count1 = { frame: 60 }

		tl.to(count1, {
			frame: 220,
			duration: 1,
			ease: 'none',
			onUpdate: () => {
				animationFirst.goToAndStop(Math.round(count1.frame), true)
			}
		}, 0)

		const count2 = { frame: 60 }

		tl.to(count2, {
			frame: 220,
			duration: 1,
			ease: 'none',
			onUpdate: () => {
				animationSecond.goToAndStop(Math.round(count2.frame), true)
			}
		}, 1)

		ScrollTrigger.refresh()

	}
}

export default () => { }